import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { showError } from '../components/Utils/toastUtils';
import PlatoSelector from '../components/PlatoSelector';
import PlatoSelectorBarcos from '../components/PlatoSelectorBarcos';
import PlatoSelectorExtras from '../components/PlatoSelectorExtras';
import PlatoSelectorEntradas from '../components/PlatoSelectorEntradas';
import ModalInicio from '../components/ModalInicio';
import InstruccionesPasoAPaso from '../components/InstruccionesPasoAPaso';
import { PageModal } from '../components/Utils/CustomStyles';
import ModalCerrado from '../components/ModalCerrado';
import { estaCerradoCaraballeda } from '../components/Utils/horariosSucursal';
import imgNav from "../img/Logotipo.webp"






const RealizarPedido = () => {
  const [seleccionEntradas, setSeleccionEntradas] = useState([]);
  const [seleccionRoles, setSeleccionRoles] = useState([]);
  const [seleccionBarcos, setSeleccionBarcos] = useState([]);
  const [seleccionExtras, setSeleccionExtras] = useState([]);
  const [interactivoBarcos, setInteractivoBarcos] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [estaCerrado, setEstaCerrado] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [mostrarModalCerrado, setMostrarModalCerrado] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (estaCerradoCaraballeda()) {
      setEstaCerrado(true);
      setMostrarModalCerrado(true);
    }
  }, []);

  const activo = () => {
    setInteractivoBarcos(true);
  };

  useEffect(() => {
    // Usamos sessionStorage para que el ciclo sea por pestaña/sesión
    const modalVisto = sessionStorage.getItem("modalVisto");
    const origenModal = sessionStorage.getItem("origenModal");

    // Si ya se vio el modal en esta sesión o el usuario viene de hacer clic en "Promos", no abrir automático
    if (modalVisto === "true" || origenModal === "promos") return;

    // Si el restaurante está cerrado, no abrir el modal de promociones
    if (estaCerrado) return;

    // El modal aparece 3 segundos después de montar la página principal
    const timeout = setTimeout(() => {
      setModalOpen(true);
      sessionStorage.setItem("modalVisto", "true"); 
    }, 3000);

    return () => clearTimeout(timeout);
  }, [estaCerrado]); 

  
  


  const handleSiguiente = () => {

      if (estaCerrado) {
      showError("Lo sentimos, estamos cerrados. No puedes continuar ahora.");
      return;
    }

  const promosGuardadas = JSON.parse(localStorage.getItem("promosSeleccionadas") || "[]");

  const todosPlatos = [
    ...seleccionEntradas,
    ...seleccionRoles,
    ...seleccionBarcos,
    ...seleccionExtras,
    ...promosGuardadas,
  ];

  

 

  if (todosPlatos.length === 0) {
    showError('Seleccioná al menos un plato');
    return;
  }

  // Si todo está OK, continuar
  setMostrarModal(true);
  setTimeout(() => {
    setMostrarModal(false);
    window.scrollTo(0, 0);
    navigate('/form');
  }, 2000);
  };


  return (
    <div className="pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] min-h-screen flex flex-col items-center justify-start px-6 py-2 sm:py-12 lg:py-4 mb-20">
     <div className="bg-white/60 p-8 sm:p-8 rounded-2xl w-full sm:max-w-md lg:max-w-4xl text-center relative mt-20 sm:mt-16 shadow-[0_0_25px_rgba(0,0,0,0.4)] mb-12">


        <ModalCerrado
          mostrar={mostrarModalCerrado}
          onContinuar={() => setMostrarModalCerrado(false)}
        />

        <ModalInicio isOpen={modalOpen} onClose={() => setModalOpen(false)} />

    <div>
      <div className="flex justify-center -mt-16 mb-2">
  <img
    src={imgNav}
    alt="Logotipo Japan Food"
    className="w-[180px] h-[180px] object-contain"
  />
</div>

        <p className="text-neutral-300 -mt-10  mb-4 font-semibold">Personaliza tu pedido antes de continuar..</p>
    </div>

 {/* 🔹 Contenedor de las secciones */}
{/* 🔹 Contenedor de las secciones */}
<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 max-w-3xl mx-auto">
  {/* Primera sección */}
  <div>
    <p className="text-left text-yellow-500 font-extrabold mb-1">Hamburguesas - Kids</p>
    <PlatoSelector
      onSeleccion={setSeleccionRoles}
      valorSeleccionado={seleccionRoles}
    />
  </div>

  {/* Segunda sección */}
  <div>
    <p className="text-left text-yellow-500 font-extrabold mb-1">Hot Dogs - Shawarmas</p>
    <PlatoSelectorEntradas
      onSeleccion={setSeleccionEntradas}
      valorSeleccionado={seleccionEntradas}
    />
  </div>

  {/* Tercera sección */}
  <div>
    <p className="text-left text-yellow-500 font-extrabold mb-1">Combos</p>
    <PlatoSelectorBarcos
      onSeleccion={setSeleccionBarcos}
      valorSeleccionado={seleccionBarcos}
      onInteractuar={activo}
    />
  </div>

  {/* Cuarta sección */}
  <div>
    <p className="text-left text-yellow-500 font-extrabold mb-1">Extras</p>
    <PlatoSelectorExtras
      onSeleccion={setSeleccionExtras}
      valorSeleccionado={seleccionExtras}
      platosDisponibles={[
        ...seleccionRoles,
        ...seleccionBarcos,
        ...seleccionEntradas,
      ]}
    />
  </div>
</div>



        

        <button
          className={`px-10 py-2 mt-4 rounded-xl transition mx-auto block ${
            estaCerrado
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-yellow-500 text-white font-extrabold"
          }`}
          onClick={handleSiguiente}
          disabled={estaCerrado}
        >
          Realizar Pedido
        </button>

        

       

      </div>
      
      <div className="w-full mt-8">
        <InstruccionesPasoAPaso />
      </div>

      <PageModal 
      mostrarModal={mostrarModal} 
      onComplete={() => setMostrarModal(false)} 
    />
    </div>
  );
};

export default RealizarPedido;
